import Sorter from "@viz-ui/services/sorters/sorter";

angular.module("acl.visualizer.sorters", []).service("Sorter", () => Sorter);
